import React from "react";
import { Link } from "react-router-dom";
import { Phone, MessageCircle, Mail } from "lucide-react";
import Logo from "./Logo";
import { CONTACT } from "../../mock";
import SEO_CONTENT from "../../seo-content.json";

const SERVICES = [["Corfu Taxi Service", "/corfu-taxi-service"], ["Holiday Transfers", "/corfu-travel-transfers"], ["Hotel & Villa Transfers", "/corfu-holiday-transportation"], ["Group Transfers", "/corfu-group-transfers"], ["VIP Transfers", "/corfu-vip-transfers"], ["Island Excursions", "/corfu-island-excursions"]];

// Discreet link directory above the footer: every route and service landing page.
const LinkDirectory = () => (
  <div className="border-b border-[#F7F3EA]/10" data-testid="footer-directory">
    <div className="max-w-7xl mx-auto px-5 sm:px-6 py-8 sm:py-10 grid lg:grid-cols-[2fr_1fr] gap-6 sm:gap-8 text-[13px]">
      <div>
        <p className="font-serif-d text-[16px] text-[#E3CBA5] mb-3">Popular routes</p>
        <ul className="flex flex-wrap gap-x-4 gap-y-1.5">
          {SEO_CONTENT.routes.map((r) => <li key={r.slug}><Link to={`/${r.slug}`} className="text-[#F7F3EA]/70 hover:text-[#E3CBA5] transition-colors">{r.from} to {r.to.split(" (")[0]}</Link></li>)}
        </ul>
      </div>
      <div>
        <p className="font-serif-d text-[16px] text-[#E3CBA5] mb-3">Our services</p>
        <ul className="flex flex-wrap gap-x-4 gap-y-1.5">
          {SERVICES.map(([l, to]) => <li key={to}><Link to={to} className="text-[#F7F3EA]/70 hover:text-[#E3CBA5] transition-colors" data-testid={`footer-service-${to.slice(1)}`}>{l}</Link></li>)}
        </ul>
      </div>
    </div>
  </div>
);

const Col = ({ title, children }) => (
  <div>
    <h4 className="font-serif-d text-[17px] sm:text-[19px] text-[#E3CBA5] mb-3 sm:mb-5">{title}</h4>
    {children}
  </div>
);

const FLink = ({ to, children }) => (
  <li><Link to={to} className="text-[14px] sm:text-[15px] text-[#F7F3EA]/90 hover:text-[#E3CBA5] transition-colors duration-200">{children}</Link></li>
);

const Footer = () => (
  <footer className="bg-[#1A3C37] text-[#F7F3EA]" data-testid="site-footer">
    <LinkDirectory />
    <div className="max-w-7xl mx-auto px-5 sm:px-6 py-10 sm:py-14 grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-8 sm:gap-10">
      <div className="col-span-2 lg:col-span-1">
        <Logo light />
        <p className="mt-5 text-[15px] text-[#F7F3EA]/85">Aloha Corfu Transfers – private airport &amp; taxi transfers in Corfu, Greece.</p>
      </div>
      <Col title="Navigation">
        <ul className="space-y-3">
          <FLink to="/">Home</FLink>
          <FLink to="/airport-transfers">Airport Transfers</FLink>
          <FLink to="/transfers/port">Port Transfers</FLink>
          <FLink to="/chauffeur">Chauffeur Service</FLink>
          <FLink to="/book">Book a Transfer</FLink>
          <FLink to="/tours">Private Tours in Corfu</FLink>
          <FLink to="/fleet">Fleet</FLink>
          <FLink to="/about">About Us</FLink>
          <FLink to="/corfu-guide">Corfu Guide</FLink>
          <FLink to="/contact">Contact</FLink>
          <FLink to="/faq">FAQ</FLink>
        </ul>
      </Col>
      <Col title="Contact">
        <ul className="space-y-3 text-[13.5px] sm:text-[15px] break-all sm:break-normal">
          <li><a href={`tel:${CONTACT.phoneRaw}`} className="flex items-center gap-2.5 hover:text-[#E3CBA5] transition-colors"><Phone className="w-4 h-4 text-[#7FB8C4]" />{CONTACT.phone}</a></li>
          <li><a href={CONTACT.whatsapp} target="_blank" rel="noreferrer" className="flex items-center gap-2.5 hover:text-[#E3CBA5] transition-colors"><MessageCircle className="w-4 h-4 text-[#7FB8C4]" />{CONTACT.phone}</a></li>
          <li><a href={`mailto:${CONTACT.email}`} className="flex items-center gap-2.5 hover:text-[#E3CBA5] transition-colors"><Mail className="w-4 h-4 text-[#7FB8C4]" />{CONTACT.email}</a></li>
          <li className="text-[#F7F3EA]/60 pt-1">Corfu, Greece · 24/7</li>
        </ul>
      </Col>
      <Col title="Legal">
        <ul className="space-y-3">
          <FLink to="/legal/privacy">Privacy Policy</FLink>
          <FLink to="/legal/terms">Terms &amp; Conditions</FLink>
          <FLink to="/legal/cookies">Cookie Policy</FLink>
          <FLink to="/legal/cancellation">Cancellation Policy</FLink>
        </ul>
      </Col>
    </div>
    <div className="border-t border-[#F7F3EA]/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 py-5 sm:py-6 flex items-center justify-between gap-4 text-[12px] sm:text-[13px] text-[#F7F3EA]/60">
        <span>© 2026 Aloha Corfu Transfers. All rights reserved.</span>
        <Link to="/admin" className="hover:text-[#F7F3EA] transition-colors" data-testid="footer-admin">Admin</Link>
      </div>
    </div>
  </footer>
);

export default Footer;
